import { useAddToCartButton } from '../hooks/useAddToCartButton';

const ButtonText = () => {
	const { blockClass, text, mzIsUnavailable, unavailableText } = useAddToCartButton();

	return (
		<div
			className={`buttonText buttonText--${blockClass} vtex-add-to-cart-button-0-x-buttonText vtex-add-to-cart-button-0-x-buttonText--${blockClass}`}
		>
			{mzIsUnavailable ? unavailableText : text}
		</div>
	);
};

export default ButtonText;
